module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921012649_T.a1f38a15.jpg";